import React from 'react';
import { TableCell, TableRow } from '@/components/ui/table';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import StatusBadge from '@/components/StatusBadge';
import { formatDate, formatGBP, shortId } from '@/lib/utils';

export const BOOKING_STATUSES = [
  'requested',
  'accepted',
  'confirmed',
  'in_progress',
  'completed',
  'cancelled',
  'refunded',
];

export default function BookingRow({ booking, updatingId, onStatusChange }) {
  return (
    <TableRow data-testid={`booking-row-${booking.id}`}>
      <TableCell className="font-mono text-xs text-slate-600">{shortId(booking.id)}</TableCell>
      <TableCell className="font-mono text-xs text-slate-600">{shortId(booking.customer_id)}</TableCell>
      <TableCell className="font-medium text-slate-900">
        {booking.partner_name || shortId(booking.partner_id)}
      </TableCell>
      <TableCell>{booking.service_name || '-'}</TableCell>
      <TableCell>{formatGBP(booking.service_price)}</TableCell>
      <TableCell>{formatGBP(booking.travel_fee)}</TableCell>
      <TableCell className="font-semibold text-slate-900">{formatGBP(booking.total_amount)}</TableCell>
      <TableCell className="text-rose-700 font-medium">{formatGBP(booking.platform_commission)}</TableCell>
      <TableCell className="text-emerald-700 font-medium">{formatGBP(booking.partner_payout)}</TableCell>
      <TableCell><StatusBadge value={booking.payment_status} /></TableCell>
      <TableCell>
        <Select
          value={booking.status}
          onValueChange={(v) => onStatusChange(booking.id, v)}
          disabled={updatingId === booking.id}
        >
          <SelectTrigger className="w-36 h-8 text-xs" data-testid={`booking-status-${booking.id}`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {BOOKING_STATUSES.map((s) => (
              <SelectItem key={s} value={s}>{s.replace(/_/g, ' ')}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </TableCell>
      <TableCell className="text-xs text-slate-500">{formatDate(booking.created_at)}</TableCell>
    </TableRow>
  );
}
